export enum AuthState { guest, loading, loggedIn };

export const authState = {
    state: AuthState.guest,
    error: null,
    user: null
}

export const downloadsState = {
    page: 1,
    limit: 20,
    total: 0,
    items: [],
    isFetching: false,
    loaded: false,
    error: null
}

export const subscriptionState = {
    page: 1,
    limit: 20,
    total: 0,
    items: [],
    isFetching: false,
    loaded: false,
    error: null
}

export const categoriesState = {
    page: 1,
    limit: 20,
    total: 0,
    items: [],
    isFetching: false,
    loaded: false,
    error: null
}

export const categoryArticlesState = {
    categories: {},
    activeCategory: null,
    page: 1,
    limit: 20,
    isFetching: false,
    loaded: false,
    error: null
}

export const documentState = {
    documents: {},
    isFetching: false,
    loaded: false,
    error: null
}

export const mobileMenuOpen = false;



// WEBPACK FOOTER //
// ./src/constants/initial-state.ts